// src/index.js

import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from "@sentry/react"; // 保持引入
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import './index.css';
import './i18n';

// ✨ 【【【核心修改：初始化 Sentry】】】 ✨
// 在所有 React 相關操作之前，盡可能早地進行初始化
Sentry.init({
  dsn: "https://0ec12692f231ead693f95fb54fb9b084@o4510078459576320.ingest.us.sentry.io/4510078478843904",
  
  // 1. 包含我們推薦的、功能更強大的整合
  integrations: [
    Sentry.browserTracingIntegration( ),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  
  // 2. 包含 Sentry 範例中提到的 PII 設定 (可選)
  sendDefaultPii: true,

  // 3. 包含我們推薦的性能和重播採樣率設定
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

// --- 您原有的程式碼保持不變 ---

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, 
      staleTime: 1000 * 60 * 5,
      retry: 1,
    },
  },
});

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);
